import FormattedMessage from 'I18n/components/FormattedMessage';
import { H3 } from 'foundations-components/transitional/components/H3';
import { getButtonVariantProps } from 'pricing-pages-lib/utils/buttonVariantUtils';
import { PPUIGridItem } from 'pricing-pages-ui-components/grid/PPUIGridItem';
import SignupButton from 'pricing-pages-ui/components/common/SignupButton';
import SkeletonLoadWrapper from 'pricing-pages-ui/components/common/loading/SkeletonLoadWrapper';
import { HighlightedProductsHeaderConfig } from 'pricing-pages-ui/constants/merchCards/HighlightedProductsHeaderConfig';
import { FREE } from 'self-service-api/constants/ProductLevels';
import { FREE_CARD } from '../../constants/tracking/TrackingSources';
import { useGlobalLoading } from '../../hooks/loadingHooks';
import HighlightedFreePriceDisplay from '../merch-card/price-display/HighlightedFreePriceDisplay';
import MobileSuiteBusinessObjectives from './MobileSuiteBusinessObjectives';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MobileHighlightedFreeCard = ({
  productLine,
  gridItemProps
}) => {
  const isAppReady = useGlobalLoading();
  const ctaVariantProps = getButtonVariantProps({
    variant: 'block'
  });

  // In order for the grid to work, we need this to remain enclosed in a Fragment and not a div.
  // Children of the display grid item must get the grid-start attributes directly
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(PPUIGridItem, Object.assign({}, gridItemProps, {
      position: "relative",
      paddingBlockStart: "600",
      gridRowStart: 1,
      showBorderTop: true,
      children: /*#__PURE__*/_jsx(H3, {
        margin: "0",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "merchCards.freeCard.title"
        })
      })
    })), /*#__PURE__*/_jsx(PPUIGridItem, Object.assign({}, gridItemProps, {
      paddingBlockStart: "600",
      gridRowStart: 2,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: productLine === 'crm' ? 'merchCards.freeCard.description.crm' : HighlightedProductsHeaderConfig[productLine][FREE].subtitle
      })
    })), /*#__PURE__*/_jsx(PPUIGridItem, Object.assign({}, gridItemProps, {
      paddingBlockStart: "400",
      gridRowStart: 3,
      children: /*#__PURE__*/_jsx(HighlightedFreePriceDisplay, {})
    })), /*#__PURE__*/_jsx(PPUIGridItem, Object.assign({}, gridItemProps, {
      paddingBlockStart: "400",
      gridRowStart: 6,
      children: /*#__PURE__*/_jsx(SkeletonLoadWrapper, {
        isLoading: !isAppReady,
        heights: [47],
        widths: ['100%'],
        children: /*#__PURE__*/_jsx(SignupButton, Object.assign({
          sourceId: "pricing-hero",
          productLine: productLine,
          use: "primary",
          trackingSource: FREE_CARD
        }, ctaVariantProps))
      })
    })), /*#__PURE__*/_jsx(PPUIGridItem, Object.assign({}, gridItemProps, {
      paddingBlockStart: "400",
      paddingBlockEnd: "600",
      showBorderBottom: true,
      gridRowStart: 8,
      children: /*#__PURE__*/_jsx(MobileSuiteBusinessObjectives, {
        productLevel: FREE
      })
    }))]
  });
};
export default MobileHighlightedFreeCard;